export const WEATHER_DAILY_ENDPOINT = 'weather/daily';
export const WEATHER_VALUE_DECIMALS = 2;
export const WEATHER_DAY_DATE_LENGTH = 'yyyy-MM-dd'.length;
